<template>
    <b-card class="mb-5">
        <b-row class="mb-0">
            <b-col md="10">
                <h3>{{$t('overtime')}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard/">{{$t('dashboard')}}</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="2 mt-3">
                <b-button v-b-tooltip.hover.top :title="$t('exportExcel')" @click="doExportToExcel" variant="info" class="mb-2 btn-download float-right"><font-awesome-icon icon="download"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-1"></div>
        <b-form v-on:submit.prevent="doFilter">
            <b-row>
                <b-col md="12">
                    <b-row class="mt-3 mb-2">
                        <b-col md="3 mb-2">
                            <b-form-input :placeholder="$t('employee')" v-model="tableFilter.search_employee"/>
                        </b-col>
                        <b-col md="3 mb-2">
                            <b-form-input :placeholder="$t('approvedBy')" v-model="tableFilter.search_approved_by"/>
                        </b-col>
                        <b-col md="3 mb-2">
                            <b-form-input :placeholder="$t('rejectedBy')" v-model="tableFilter.search_rejected_by"/>
                        </b-col>
                        <b-col md="3 mb-2">
                            <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> {{$t('filter')}}</button>
                            <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> {{$t('clear')}}</button>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col md="3 mb-2">
                            <b-form-select v-model="tableFilter.overtimeType" :options="overtimeList" />
                        </b-col>
                        <b-col md="3 mb-2">
                            <b-form-select v-model="tableFilter.statusOvertime" :options="statusList" />
                        </b-col>
                        <b-col md="3 mb-2">
                            <date-picker v-model="tableFilter.date" type="date" range :placeholder="$t(dateRange)"></date-picker>
                        </b-col>
                    </b-row>
                    <!-- <b-row>
                        <b-col md="12 mt-1 mb-4">
                            <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Search</button>
                            <button @click="clearFilter()" class="btn btn-danger float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Search</button>
                        </b-col>
                    </b-row> -->
                </b-col>
            </b-row>
        </b-form>
        <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :data-url="apiUrl.overtime" :data-key="dataKey" :data-columns="columns" :data-params="['search_employee', 'overtime_type_uuid', 'ot_start_date', 'ot_end_date', 'search_approved_by', 'search_rejected_by', 'status']">
            <template slot="content_overtimeType" slot-scope="defaultSlotScope">
                {{defaultSlotScope}}
            </template>
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import Typeahead from '@/components/Typeahead'
    export default {
        name: 'report-index',
        components: {
            PaginatedTable,
            DatePicker,
            Typeahead
        },
        data: function() {
        var currentDate = new Date();
        var monthlymonth = new Date(currentDate)
        var twoDigitFirstMonth= ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
        var twoDigitFirstDate= "01";
        var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;

        var currentDate = new Date();
        var monthly = new Date(currentDate)
        var thismonth = ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
        var twoDigitFirstDates= "31";
        var thismonthday = currentDate.getFullYear() + "-" + thismonth + "-" + twoDigitFirstDates;

            return {
                dataKey: 'overtime',
                apiUrl: {
                    profile : window.AppConfig.apiUrl + 'profile',
                    overtime : window.AppConfig.apiUrl + 'overtime',
                    OvertimeType: window.AppConfig.apiUrl + 'overtime-type',
                    exportOvertime: window.AppConfig.apiUrl + 'export-overtime-general'
                },
                thismonthday: thismonthday,
                createdDateTo: createdDateTo,
                overtimeList: [
                    {
                        value: null,
                        text: this.$root.$t('type')
                    }
                ],
                statusList: [
                    {
                        value: null,
                        text: 'Status'
                    },
                    {
                        value: 'Requested',
                        text: this.$root.$t('req')
                    },
                    {
                        value: 'Approved',
                        text: this.$root.$t('appr')
                    },
                    {
                        value: 'Rejected',
                        text: this.$root.$t('rej')
                    },
                    {
                        value: 'Canceled',
                        text: this.$root.$t('can')
                    }
                ],
                columns: [
                    {
                        key: 'requestedBy',
                        label: this.$root.$t('employee'),
                        sortable: true
                    },
                    {
                        key: 'createdAt',
                        label: this.$root.$t('CREATED'),
                        sortable: true
                    },
                    {
                        key: 'hour',
                        label: this.$root.$t('totalHour'),
                        sortable: true
                    },
                    {
                        key: 'overtimeType',
                        label: this.$root.$t('type'),
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: this.$root.$t('note'),
                    },
                    {
                        key: 'statusLeave',
                        label: 'Status'
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                tableFilter: {
                    overtimeType: null,
                    status: this.$route.query.status,
                    statusOvertime: null,
                    search_approved_by: this.$route.query.search_approved_by,
                    search_rejected_by: this.$route.query.search_rejected_by,
                    search_employee: this.$route.query.search_employee,
                    overtime_type_uuid: this.$route.query.overtime_type_uuid,
                    date: null,
                    ot_start_date: this.$route.query.ot_start_date,
                    ot_end_date: this.$route.query.ot_end_date,
                    userRequestedBy: {
                        value: null
                    },
                    userApprovedBy: {
                        value: null
                    },
                    userRejectedBy: {
                        value: null
                    }
                }
            }
        },
        watch: {
            // 'tableFilter.userRequestedBy' (value) {
            //     this.tableFilter.requestedBy = value ? 1 : null
            //     this.doFilter()
            // },
            // 'tableFilter.date' (value) {
            //     if (value !== null && value.length >= 1 && value[0] === null && value[1] === null) {
            //         this.tableFilter.date = null
            //         this.doFilter()
            //     } else {
            //         this.doFilter()
            //     }
            // },
            // 'tableFilter.overtimeType' () {
            //     this.doFilter()
            // },
            // 'tableFilter.statusOvertime' () {
            //     this.doFilter()
            // }
        },
        mounted () {
            this.getOvertimeType()
            // this.doFilter()
        },
        methods: {
            getOvertimeType () {
                this.$http.get(this.apiUrl.OvertimeType + '?limit=100').then(resp => {
                    resp.data._embedded.overtimeType.forEach(data => {
                        this.overtimeList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            doExportToExcel () {
              let url = this.apiUrl.exportOvertime + '?token=' + this.$store.getters['account/tokens'].access_token
            //   if (this.tableFilter.requested_by !== undefined && this.tableFilter.requested_by !== null) {
            //     url += '&requested_by=' + this.tableFilter.requested_by
            //   }
              if (this.tableFilter.search_employee !== undefined && this.tableFilter.search_employee !== null) {
                url += '&search_employee=' + this.tableFilter.search_employee
              }
              if (this.tableFilter.search_approved_by !== undefined && this.tableFilter.search_approved_by !== null) {
                url += '&search_approved_by=' + this.tableFilter.search_approved_by
              }
              if (this.tableFilter.search_rejected_by !== undefined && this.tableFilter.search_rejected_by !== null) {
                url += '&search_rejected_by=' + this.tableFilter.search_rejected_by
              }
              if (this.tableFilter.overtime_type_uuid !== undefined && this.tableFilter.overtime_type_uuid !== null) {
                url += '&overtime_type_uuid=' + this.tableFilter.overtime_type_uuid
              }
              if (this.tableFilter.status !== undefined && this.tableFilter.status !== null) {
                url += '&status=' + this.tableFilter.status
              }
              if (this.tableFilter.date !== null) {
                url += '&ot_start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&ot_end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
              } 
              if (this.tableFilter.ot_start_date === this.createdDateTo && this.tableFilter.ot_end_date === this.thismonthday && this.tableFilter.status === 'Approved') {
                url += '&ot_start_date=' + this.createdDateTo + '&ot_end_date=' + this.thismonthday + '&status=Approved'
              }
              window.open(url)
            },
            doFilter () {
                this.tableFilter.overtime_type_uuid = this.tableFilter.overtimeType
                this.tableFilter.status = this.tableFilter.statusOvertime
                this.tableFilter.ot_start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
                this.tableFilter.ot_end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            clearFilter () {
                this.tableFilter.overtimeType = null
                this.tableFilter.statusOvertime = null
                this.tableFilter.search_employee = null
                this.tableFilter.search_approved_by = null
                this.tableFilter.search_rejected_by = null
                this.tableFilter.date = null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            },
            reset () {
                this.tableFilter.requestedBy = null
            }
        }
    }
</script>